import { render, staticRenderFns } from "./tabPotongan.vue?vue&type=template&id=7b0e156d"
import script from "./tabPotongan.vue?vue&type=script&lang=js"
export * from "./tabPotongan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports